import { Suspense, lazy, useState } from "react";
import { useServices } from "../app/services";

// モックのときだけ読み込む（本番のビルドでは条件が定数になり、MockPanel もモックも成果物に入らない）
const MockPanel =
  import.meta.env.VITE_API_MODE === "mock" || (import.meta.env.DEV && import.meta.env.VITE_API_MODE !== "http")
    ? lazy(() => import("./MockPanel"))
    : null;

/**
 * 開発用モックの帯。モックのあいだは、どの画面でも必ず出す（本物の結果と取り違えないように）。
 * HTTP につないでいるとき（本番のビルドの既定）は出ない
 */
export function MockBanner() {
  const { api } = useServices();
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  if (api.mode !== "mock" || !MockPanel) return null;
  return (
    <>
      <aside className="mock-banner" aria-label="開発用モックのお知らせ">
        <span className="mock-banner__badge">開発用モック</span>
        <span className="mock-banner__text">
          <span className="mock-banner__long">表示はサンプルです。操作はどこにも保存・送信されません。</span>
          <span className="mock-banner__short">表示はサンプルです</span>
        </span>
        <button
          type="button"
          className="mock-banner__btn"
          aria-label="モックの状況を切りかえる"
          onClick={() => {
            setLoaded(true);
            setOpen(true);
          }}
          aria-haspopup="dialog"
        >
          <span className="mock-banner__long">状況を</span>切りかえる
        </button>
      </aside>
      {loaded && (
        <Suspense fallback={null}>
          <MockPanel open={open} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
